import { Card, type SelectOption, Select, type SelectComponent, SettingsLayout } from "@clintonelec/react-storybook";
import ActionButtons from "Components/ConfigLayout/ActionButtons";
import { Languages } from "Data/Objects/Languages";
import { selectLanguage, setLanguageAction } from "Data/Redux/Slices/Settings/System/Language";
import { useAppDispatch, useAppSelector } from "Data/Redux/Store";
import { type FormEvent, type SubmitEvent as ReactSubmitEvent, memo, useRef, useState } from "react";

const languageOptions: SelectOption[] = [
	{
		label: Languages.ENGLISH,
		value: Languages.ENGLISH
	},
	{
		label: Languages.KOREAN,
		value: Languages.KOREAN
	}
];

type SystemLanguageForm = {
	languageOptions: SelectComponent;
} & HTMLFormElement;

function LanguageSettings() {
	const selectRef = useRef<SelectComponent>(null);
	const language = useAppSelector(selectLanguage);
	const dispatch = useAppDispatch();
	const [ localLanguage, setLocalLanguage ] = useState(language);
	const setSystemLanguage = (lang: Languages) => dispatch(setLanguageAction(lang));

	const handleSubmit = (event: ReactSubmitEvent<SystemLanguageForm>) => {
		event.preventDefault();

		const { languageOptions: { value: systemLanguage } } = event.currentTarget;

		setSystemLanguage(systemLanguage);
	};

	const handleReset = (event: FormEvent<SystemLanguageForm>) => {
		event.preventDefault();
		selectRef.current?.setValue(
			languageOptions.find(option => option.value === language)
		);
	};

	const handleSelect = (value: string | null) => {
		if (!value) {
			return;
		}

		setLocalLanguage(value as Languages);
	};

	return (
		<SettingsLayout.Form onReset={ handleReset } onSubmit={ handleSubmit }>
			<SettingsLayout.ScrollableContainer>
				<Card size="small" title="Language">
					<div className="form-row">
						<span>Language</span>
						<Select
							allowClear={ false }
							className="form-select"
							forwardRef={ selectRef }
							name="languageOptions"
							onSelect={ handleSelect }
							options={ languageOptions }
							value={ language }
						/>
					</div>
				</Card>
			</SettingsLayout.ScrollableContainer>
			<ActionButtons disabled={ localLanguage === language } />
		</SettingsLayout.Form>
	);
}

export default memo(LanguageSettings);
